"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DiagramFallDown: ['diagram-fall-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 20.25L12 23.25 15 20.25', 'M.75.75v6a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5v-6', 'M12 8.25L12 23.25']],
  DiagramArrowDashLeft: ['diagram-arrow-dash-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,8.621h-6V5.511c0-.272-.163-.343-.362-.158L1,11.04a.751.751,0,0,0,.017,1.142l6.116,5.336c.2.185.362.114.362-.157v-2.74h6', 'M16.5 8.621L18.75 8.621', 'M21 8.621L23.25 8.621', 'M16.5 14.621L18.75 14.621', 'M21 14.621L23.25 14.621']],
  DiagramArrowDashUp: ['diagram-arrow-dash-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75 23.25L0.75 23.25', 'M17.25 23.25L6.75 23.25', 'M23.25 23.25L20.251 23.25', 'M20.25 18.75L23.25 18.75', 'M6.75,18.75H9V7.5H5.87c-.269,0-.34-.161-.157-.358L11.447,1A.75.75,0,0,1,12.564,1l5.951,6.147c.183.2.113.358-.156.358H15V18.75h2.25', 'M0.75 18.75L3.75 18.75']],
  DiagramDashUpSteady: ['diagram-dash-up-steady', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 6.75L23.25 3.75 20.25 0.75', 'M0.75 23.25L3.837 23.25', 'M6.874,21.981a3.971,3.971,0,0,0,1.034-2.825', 'M7.908 15.76L7.908 12.673', 'M7.908,9.276A9.059,9.059,0,0,1,8.163,6.22', 'M10.508,3.986a9.875,9.875,0,0,1,3.061-.231', 'M23.25 3.75L18 3.75']],
  DiagramLowerSteady: ['diagram-lower-steady', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 13.5L23.25 10.533 20.25 7.5', 'M23.25,10.5H12a3.019,3.019,0,0,0-3,2.967v6.848A2.991,2.991,0,0,1,6,23.25H3.685A2.935,2.935,0,0,1,.75,20.315V.75']],
  DiagramMergeDown: ['diagram-merge-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 19L12 22 15 19', 'M12,22V8.488A6,6,0,0,0,5.947,2.5H.75', 'M12,8.488A6,6,0,0,1,18.053,2.5h5.2']],
  DiagramSnakeArrow: ['diagram-snake-arrow', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 20.25L12 23.25 15 20.25', 'M11.25.75v1.5a3,3,0,0,0,3,3H21a2.25,2.25,0,0,1,0,4.5H3a2.25,2.25,0,0,0,0,4.5H9a3,3,0,0,1,3,3v6']],
  DiagramArrowCornerPointLeft: ['diagram-arrow-corner-point-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.989,6.951,7.138.853c.2-.185.362-.114.362.158V4.5H21.75A1.5,1.5,0,0,1,23.25,6V21.75a1.5,1.5,0,0,1-1.5,1.5H19.5a1.5,1.5,0,0,1-1.5-1.5V12a1.5,1.5,0,0,0-1.5-1.5h-9v3.489c0,.272-.163.343-.362.158L.989,8.049a.75.75,0,0,1,0-1.1Z']],
  DiagramArrowCornerPointRight: ['diagram-arrow-corner-point-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.011,6.951,16.862.853c-.2-.185-.362-.114-.362.158V4.5H2.25A1.5,1.5,0,0,0,.75,6V21.75a1.5,1.5,0,0,0,1.5,1.5H4.5A1.5,1.5,0,0,0,6,21.75V12a1.5,1.5,0,0,1,1.5-1.5h9v3.489c0,.272.163.343.362.158l6.149-6.1a.75.75,0,0,0,0-1.1Z']],
  DiagramArrowDashCornerLeftUp: ['diagram-arrow-dash-corner-left-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 13.5L19.125 15.375', 'M21.375 17.625L23.25 19.5', 'M11.25,15,3.75,7.5,1.39,9.86A.375.375,0,0,1,.75,9.6V1.125A.375.375,0,0,1,1.125.75H9.6a.375.375,0,0,1,.265.64L7.5,3.75l7.5,7.5', 'M13.5 17.25L15.375 19.125', 'M17.625 21.375L19.5 23.25']],
  DiagramArrowDashCornerPointLeft: ['diagram-arrow-dash-corner-point-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 19.5L23.25 23.25', 'M18,16.5V12a1.5,1.5,0,0,0-1.5-1.5h-9v3.489c0,.272-.163.343-.362.158L.989,8.049a.75.75,0,0,1,0-1.1L7.138.853c.2-.185.362-.114.362.158V4.5H21.75A1.5,1.5,0,0,1,23.25,6V16.5', 'M18 23.25L18 19.5']],
  DiagramArrowDashCornerPointRight: ['diagram-arrow-dash-corner-point-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 19.5L0.75 23.25', 'M6,16.5V12a1.5,1.5,0,0,1,1.5-1.5h9v3.489c0,.272.163.343.362.158l6.149-6.1a.75.75,0,0,0,0-1.1L16.862.853c-.2-.185-.362-.114-.362.158V4.5H2.25A1.5,1.5,0,0,0,.75,6V16.5', 'M6 23.25L6 19.5']],
  DiagramArrowDashCornerRightDown: ['diagram-arrow-dash-corner-right-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75 10.5L4.875 8.625', 'M2.625 6.375L0.75 4.5', 'M12.75,9l7.5,7.5,2.36-2.36a.375.375,0,0,1,.64.265v8.47a.375.375,0,0,1-.375.375h-8.47a.375.375,0,0,1-.265-.64l2.36-2.36L9,12.75', 'M10.5 6.75L8.625 4.875', 'M6.375 2.625L4.5 0.75']],
  DiagramArrowDashDown: ['diagram-arrow-dash-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 0.75L23.25 0.75', 'M6.75 0.75L17.25 0.75', 'M0.75 0.75L3.749 0.75', 'M3.75 5.25L0.75 5.25', 'M17.25,5.25H15V16.5h3.131c.268,0,.339.161.156.359L12.553,23a.751.751,0,0,1-1.117.01L5.485,16.859c-.183-.2-.113-.359.156-.359H9V5.25H6.75', 'M23.25 5.25L20.25 5.25']],
  DiagramArrowDashDown1: ['diagram-arrow-dash-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.75,10.5v6h3.111c.271,0,.342.163.157.362L12.331,23a.751.751,0,0,1-1.142-.017L5.853,16.862c-.185-.2-.114-.362.158-.362H8.75v-6', 'M14.75 7.5L14.75 5.25', 'M14.75 3L14.75 0.75', 'M8.75 7.5L8.75 5.25', 'M8.75 3L8.75 0.75']],
  DiagramArrowBendDown: ['diagram-arrow-bend-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.96 6.921L11.46 6.921', 'M6.21 0.921L0.96 0.921', 'M20.46,16.671h2.165a.376.376,0,0,1,.28.625l-5.181,5.828a.374.374,0,0,1-.545.016L11.35,17.312a.376.376,0,0,1,.265-.641H14.46v-7.5c0-5.163-1.428-8.25-8.25-8.25h9.2c3.537,0,5.053,2.263,5.053,5.053Z']],
  DiagramArrowBow: ['diagram-arrow-bow', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 9L23.25 12 20.25 15', 'M0.75 12L23.25 12', 'M1,.75A11.374,11.374,0,0,1,12.489,12,11.374,11.374,0,0,1,1,23.25']],
  DiagramAllDirectionExpand: ['diagram-all-direction-expand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.75L12 23.25', 'M9 3.75L12 0.75 15 3.75', 'M9 20.25L12 23.25 15 20.25', 'M23.25 12L0.75 12', 'M20.25 9L23.25 12 20.25 15', 'M3.75 9L0.75 12 3.75 15']],
  DiagramArrowDiagonal1: ['diagram-arrow-diagonal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.721,16.408,1.128,14.277c-.207-.172-.377-.093-.378.176v8.308a.488.488,0,0,0,.487.489h8.34c.269,0,.347-.168.174-.374L7.582,20.3', 'M7.631 20.318L20.298 7.581', 'M16.408 3.72L3.721 16.408', 'M16.408,3.72,14.277,1.128c-.172-.207-.093-.377.176-.378h8.308a.488.488,0,0,1,.489.487v8.34c0,.269-.168.347-.374.174L20.3,7.581']],
  DiagramArrowDown1: ['diagram-arrow-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.75L23.25 0.75', 'M23.25,5.25H15V16.5h3.131c.268,0,.339.161.156.358L12.553,23a.75.75,0,0,1-1.117.009L5.485,16.858c-.183-.2-.113-.358.156-.358H9V5.25H.75']],
  DiagramArrowDownRightCorner: ['diagram-arrow-down-right-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.324.905,20.278,16.341l2.554-2.151c.208-.174.38-.094.381.177l.037,8.389a.493.493,0,0,1-.491.494H14.365c-.271,0-.35-.17-.175-.377l2.19-2.6L.889,4.846A.46.46,0,0,1,.908,4.17L4.612.878A.519.519,0,0,1,5.324.905Z']],
  DiagramArrowUpAndRight: ['diagram-arrow-up-and-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 23.25L9 17.25 16.5 17.25 16.5 21 23.25 15 16.5 9 16.5 12.75 9 12.75 9 7.5 12.75 7.5 6.75 0.75 0.75 7.5 4.5 7.5 4.5 23.25']],
  DiagramArrowUp1: ['diagram-arrow-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 23.25L0.75 23.25', 'M.75,18.75H9V7.5H5.869c-.268,0-.339-.161-.156-.358L11.447,1A.75.75,0,0,1,12.564,1l5.951,6.147c.183.2.113.358-.156.358H15V18.75h8.25']],
  DiagramCurveRiseDash: ['diagram-curve-rise-dash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 13.257L20.25 10.257 17.25 13.257', 'M.75,12.507l.008-2.25a3.607,3.607,0,0,1,.128-.844', 'M2.8,6.978a5.234,5.234,0,0,1,2.817-.471', 'M8.687,7.108A3.9,3.9,0,0,1,10.36,9.387', 'M10.5 12.559L10.5 15.454', 'M11.312,18.458a3.988,3.988,0,0,0,2.412,1.48', 'M16.9,19.971A3.777,3.777,0,0,0,19.371,18.6', 'M20.25 15.613L20.25 10.257']],
  DiagramCurveUp: ['diagram-curve-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 8.25L23.25 5.25 20.25 2.25', 'M.75.75v16.5a6,6,0,0,0,12,0V9.75a4.5,4.5,0,0,1,4.5-4.5h6']],
  DiagramArrowUp: ['diagram-arrow-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.25,23.25a1.5,1.5,0,0,1-1.5-1.5V7.5H5.261c-.272,0-.343-.163-.158-.362L11.2.989a.75.75,0,0,1,1.1,0l6.1,6.149c.185.2.114.362-.158.362H14.75V21.75a1.5,1.5,0,0,1-1.5,1.5Z']],
  DiagramArrowUpLeftCorner: ['diagram-arrow-up-left-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.1,18.676,7.659,3.722,9.81,1.168C9.984.96,9.9.788,9.633.787L1.244.75a.493.493,0,0,0-.494.491V9.635c0,.271.17.35.378.175l2.6-2.19L19.154,23.111a.46.46,0,0,0,.676-.019l3.292-3.7A.519.519,0,0,0,23.1,18.676Z']],
  DiagramCurveRise: ['diagram-curve-rise', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 11.5L20.25 8.5 17.25 11.5', 'M.75,11.5V8.663A3.913,3.913,0,0,1,4.663,4.75H6.62A3.885,3.885,0,0,1,10.5,8.663v5.674a3.941,3.941,0,0,0,3.946,3.913H16.4a3.858,3.858,0,0,0,3.848-3.913V8.5']],
  DiagramDashDownFast: ['diagram-dash-down-fast', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 20.25L20.25 23.25 23.25 20.25', 'M0.75 0.75L0.75 3.838', 'M2.019,6.874A3.971,3.971,0,0,0,4.844,7.908', 'M8.24 7.908L11.327 7.908', 'M14.724,7.908a9.059,9.059,0,0,1,3.056.255', 'M20.014,10.508a9.875,9.875,0,0,1,.231,3.061', 'M20.25 23.25L20.25 18']],
  DiagramDashFastUp: ['diagram-dash-fast-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.749,19.4a7.83,7.83,0,0,0,5.661-5.627L21.069,3.5', 'M0.73 19.641L2.27 19.641', 'M4.73 19.641L6.27 19.641', 'M8.877 19.641L10.417 19.641', 'M17.538 5.681L21.069 3.5 23.25 7.032']],
  DiagramCurvy: ['diagram-curvy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 8.25L23.25 5.25 20.25 2.25', 'M.75,17.25a6,6,0,0,0,12,0V9.75a4.5,4.5,0,0,1,4.5-4.5h6', 'M0.75 11.25L0.75 14.25', 'M0.75 5.25L0.75 8.25', 'M0.75 2.25L0.75 0.75']],
  DiagramCurvyBothDirection: ['diagram-curvy-both-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 7.5L23.25 4.5 20.25 1.5', 'M3.75 16.5L0.75 19.5 3.75 22.5', 'M23.25,4.5H10.5a3.75,3.75,0,0,0,0,7.5h3a3.75,3.75,0,0,1,0,7.5H.75']],
  DiagramDashRiseSteady: ['diagram-dash-rise-steady', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 11.985L23.25 8.985 20.25 5.985', 'M0.75 18.735L3.83 18.735', 'M7,18.735a3.239,3.239,0,0,0,2.652-.853', 'M10.5 14.937L10.5 12.056', 'M11.947,9.408a5.045,5.045,0,0,1,2.8-.423', 'M17.92 8.985L23.25 8.985']],
  DiagramFallFast: ['diagram-fall-fast', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 19.5L20.25 23.25 23.25 19.5', 'M20.25,23.25v-8.8A3.941,3.941,0,0,0,16.337,10.5H4.663A3.885,3.885,0,0,1,.75,6.62V.75']],
  DiagramFallFastDash: ['diagram-fall-fast-dash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 19.5L20.25 23.25 23.25 19.5', 'M20.25 23.25L20.25 17.52', 'M20.233,14.113a3.971,3.971,0,0,0-1.383-2.684', 'M15.665 10.5L12.568 10.5', 'M9.16 10.5L6.063 10.5', 'M2.741,10A3.873,3.873,0,0,1,.886,7.626', 'M0.75 4.23L0.75 0.75']],
  DiagramFallRiseSteady: ['diagram-fall-rise-steady', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 13.268L23.25 10.301 20.25 7.268', 'M23.25 10.268L15.938 10.268', 'M12.482,10.268a3.2,3.2,0,0,0-2.8,1.112', 'M9 14.677L9 17.818', 'M8.753,21.239A3.057,3.057,0,0,1,6.32,23', 'M2.876,22.9A2.948,2.948,0,0,1,.822,20.725', 'M0.75 17.275L0.75 14.133', 'M0.75 10.677L0.75 7.536', 'M0.75 4.08L0.75 0.938']],
  DiagramDashUpThenDown: ['diagram-dash-up-then-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.576,2.75a8.256,8.256,0,0,0,.489,16.5H23.25', 'M14.422,2.75H12.451', 'M18.815,2.75H17.106', 'M23.25,2.75H21.173', 'M20.25 22.25L23.25 19.25 20.25 16.25']],
  DiagramDashWaveDown: ['diagram-dash-wave-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.75L3.85 0.759', 'M6.42,2.391a6.065,6.065,0,0,1,.33,2.836', 'M6.75 8.408L6.75 11.3', 'M6.75 14.481L6.75 17.373', 'M6.762,20.554a2.949,2.949,0,0,0,1.506,2.332', 'M11.374,23.12a3.035,3.035,0,0,0,1.992-1.944', 'M13.5 18.009L13.5 15.117', 'M13.5 11.936L13.5 9.044', 'M13.5,5.863V4.417a5.582,5.582,0,0,1,.093-1.438', 'M15.752.85a5.533,5.533,0,0,1,1.437-.1,2.971,2.971,0,0,1,1.4.3', 'M20.244 3.578L20.25 6.47', 'M20.25 9.651L20.25 15.001', 'M17.25 11.251L20.25 15.001 23.25 11.251']],
  DiagramDown: ['diagram-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,20.242c-.353.018-1.2,0-1.554,0A20.925,20.925,0,0,1,.75.75', 'M20.25 17.25L23.25 20.25 20.25 23.25']],
  DiagramIncrease: ['diagram-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.069,3.859,18.41,14.135A7.827,7.827,0,0,1,10.833,20H.75', 'M17.538 6.039L21.069 3.859 23.25 7.39']],
  DiagramSteadyDown1: ['diagram-steady-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.859,1.915Q.789,1.338.75.75', 'M1.8,6.044a20.647,20.647,0,0,1-.574-2.037', 'M3.977,10.579A20.724,20.724,0,0,1,2.6,8.069', 'M23.25,20.242c-.353.018-1.2,0-1.554,0A21.009,21.009,0,0,1,5.25,12.353', 'M20.25 17.25L23.25 20.25 20.25 23.25']],
  DiagramUpDouble: ['diagram-up-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 3.75L20.25 0.75 17.25 3.75', 'M6.75 3.75L3.75 0.75 0.75 3.75', 'M20.25.75V15a8.25,8.25,0,0,1-16.5,0V.75']],
  DiagramUpThenDown: ['diagram-up-then-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,2.5H9.065a8.25,8.25,0,1,0,0,16.5H23.25', 'M20.25 22L23.25 19 20.25 16']],
  DiagramSplitVertical: ['diagram-split-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75 0.75L0.75 3.75 3.75 6.75', 'M12,23.25V9.738A6,6,0,0,0,5.947,3.75H.75', 'M20.25 0.75L23.25 3.75 20.25 6.75', 'M12,9.738A6,6,0,0,1,18.053,3.75h5.2']],
  DiagramSteadyAndFall: ['diagram-steady-and-fall', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 10.5L23.25 13.5 20.25 16.5', 'M12.75 20.25L9.75 23.25 6.75 20.25', 'M.75.75v8.8A3.941,3.941,0,0,0,4.663,13.5H23.25', 'M9.75 13.5L9.75 23.25']],
  DiagramSteadyDown: ['diagram-steady-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25 20L11.25 23 8.25 20', 'M.75,12.5H17.625a5.625,5.625,0,0,0,0-11.25A6.375,6.375,0,0,0,11.25,7.625V23']],
  DiagramWaveBothDirection: ['diagram-wave-both-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 7.5L23.25 4.5 20.25 1.5', 'M3.75 16.5L0.75 19.5 3.75 22.5', 'M23.25 4.5L17.715 4.5', 'M14.424 4.5L11.433 4.5', 'M8.3,5.221a3.749,3.749,0,0,0-1.5,2.492', 'M7.719,10.759a3.74,3.74,0,0,0,2.636,1.234', 'M13.645,12.007a3.74,3.74,0,0,1,2.636,1.234', 'M17.207,16.287a3.749,3.749,0,0,1-1.5,2.492', 'M12.567 19.5L9.576 19.5', 'M6.285 19.5L0.75 19.5']],
  DiagramWaveDown: ['diagram-wave-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75.75h3a3,3,0,0,1,3,3V19.875a3.375,3.375,0,0,0,6.75,0V4.125a3.375,3.375,0,0,1,6.75,0V15', 'M17.25 11.25L20.25 15 23.25 11.25']],
  DiagramUp: ['diagram-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.242.75c.018.353,0,1.2,0,1.554A20.925,20.925,0,0,1,.75,23.25', 'M17.25 3.75L20.25 0.75 23.25 3.75']],
  DiagramArrowDashUp1: ['diagram-arrow-dash-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.75,13.5v-6H5.639c-.271,0-.342-.163-.157-.362L11.169,1a.751.751,0,0,1,1.142.017l5.336,6.116c.185.2.114.362-.158.362H14.75v6', 'M8.75 16.5L8.75 18.75', 'M8.75 21L8.75 23.25', 'M14.75 16.5L14.75 18.75', 'M14.75 21L14.75 23.25']],
  DiagramCurveDown: ['diagram-curve-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 20.25L20.25 23.25 23.25 20.25', 'M.75.75v6A3.777,3.777,0,0,0,4.663,10.5H16.4a4,4,0,0,1,3.848,4.076V23.25']],
  DiagramDashSteadyUp: ['diagram-dash-steady-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.25 20.25L4.179 20.25', 'M7.4 20.25L10.328 20.25', 'M13.461,19.6a7.871,7.871,0,0,0,2.4-1.64', 'M17.62,15.288c.348-.912.535-1.876.795-2.816', 'M19.223 9.354L19.957 6.519', 'M17.049 5.181L20.58 3 22.761 6.532']],
  DiagramArrowDashRight: ['diagram-arrow-dash-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.5,9.121h6V6.011c0-.272.163-.343.362-.158L23,11.54a.751.751,0,0,1-.017,1.142l-6.116,5.336c-.2.185-.362.114-.362-.157v-2.74h-6', 'M7.5 9.121L5.25 9.121', 'M3 9.121L0.75 9.121', 'M7.5 15.121L5.25 15.121', 'M3 15.121L0.75 15.121']],
  DiagramArrowRight: ['diagram-arrow-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,10a1.5,1.5,0,0,1,1.5-1.5H16.5V5.011c0-.272.163-.343.362-.158l6.149,6.1a.75.75,0,0,1,0,1.1l-6.149,6.1c-.2.185-.362.114-.362-.158V14.5H2.25A1.5,1.5,0,0,1,.75,13Z']],
  DiagramArrowDiagonal: ['diagram-arrow-diagonal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.408,20.279l-2.131,2.593c-.172.207-.093.377.176.378h8.308a.488.488,0,0,0,.489-.487v-8.34c0-.269-.168-.347-.374-.174L20.3,16.418', 'M20.318 16.369L7.581 3.702', 'M3.72 7.592L16.408 20.279', 'M3.72,7.592,1.128,9.723C.921,9.9.751,9.816.75,9.547V1.239A.488.488,0,0,1,1.237.75h8.34c.269,0,.347.168.174.374L7.581,3.7']],
  DiagramSplitHorizontal: ['diagram-split-horizontal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 3.75L20.25 0.75 17.25 3.75', 'M.75,12H14.262A6,6,0,0,0,20.25,5.947V.75', 'M23.25 20.25L20.25 23.25 17.25 20.25', 'M14.262,12a6,6,0,0,1,5.988,6.053v5.2']],
  DiagramZigZagFall: ['diagram-zig-zag-fall', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25 20.25L11.25 23.25 14.25 20.25', 'M11.25 0.75L11.25 7.5 16.5 7.5 6.75 14.25 11.25 14.25 11.25 23.25']],
  DiagramRound: ['diagram-round', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 15.451L3.07 11.893 6.628 14.212', 'M13.238,2.227a10.012,10.012,0,1,1,0,20.023A10.174,10.174,0,0,1,3.07,11.893']],
  DiagramFastUp: ['diagram-fast-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.915,23.141q-.578.071-1.165.109', 'M6.044,22.2a20.647,20.647,0,0,1-2.037.574', 'M10.579,20.023A20.724,20.724,0,0,1,8.069,21.4', 'M20.242.75c.018.353,0,1.2,0,1.554A21.009,21.009,0,0,1,12.353,18.75', 'M17.25 3.75L20.25 0.75 23.25 3.75']],
  DiagramDashCircle: ['diagram-dash-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.758 14.008L3.758 11.008 6.758 14.008', 'M15.835,2.585a9.637,9.637,0,0,1,2.808,1.237', 'M21.135,6.1a9.547,9.547,0,0,1,1.492,2.681', 'M23.25,12.092a10.544,10.544,0,0,1-.419,3.042', 'M21.319,18.149a9.39,9.39,0,0,1-2.17,2.17', 'M16.134,21.831a10.544,10.544,0,0,1-3.042.419', 'M9.777,21.627A9.561,9.561,0,0,1,7.1,20.135', 'M4.822,17.643a9.61,9.61,0,0,1-1.237-2.808']],
  DiagramArrowLeft: ['diagram-arrow-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,10.75a1.5,1.5,0,0,0-1.5-1.5H7.5V5.761c0-.272-.163-.343-.362-.158L.989,11.7a.75.75,0,0,0,0,1.1l6.149,6.1c.2.185.362.114.362-.158V15.25H21.75a1.5,1.5,0,0,0,1.5-1.5Z']],
  DiagramArrowDown: ['diagram-arrow-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.25.75a1.5,1.5,0,0,1,1.5,1.5V16.5h3.489c.272,0,.343.163.158.362l-6.1,6.149a.75.75,0,0,1-1.1,0L5.1,16.862c-.185-.2-.114-.362.158-.362H8.75V2.25a1.5,1.5,0,0,1,1.5-1.5Z']],
  DiagramCurveUp1: ['diagram-curve-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 6.75L23.25 3.75 20.25 0.75', 'M.75,23.25h6a3.777,3.777,0,0,0,3.75-3.913V7.6A4,4,0,0,1,14.576,3.75H23.25']],
  DiagramSteadyRise: ['diagram-steady-rise', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 11L23.25 8 20.25 5', 'M.75,17.75H7.6a2.907,2.907,0,0,0,2.9-2.935v-3.88A2.962,2.962,0,0,1,13.467,8H23.25']]
};
exports["default"] = _default;